import React from 'react';

const Spacer = ({height}) => {
  return (
    <div className="spacer" style={{height: `${height}px`}}/>
    
  )
}

export default Spacer